<template>
    <carousel classes="review-carousel" :items="items" :options="options" :show-navigation="showNavigation">
        <template #slide="{ item }">
            <div class="reviews-slider-item">
                <div class="reviews-slider-item-header">
                    <div class="reviews-slider-item-header-icon" style="background: #03dbe8;">{{ item.author.charAt(0) }}</div>
                    <div class="reviews-slider-item-header-block">
                        <div>
                            <span class="name">{{ item.author }}</span>
                            <span class="date">{{ item.posted_at }}</span>
                            <span v-if="item.city" class="city">{{ item.city }}</span>
                        </div>
                        <div>
                            <div class="product-rating">
                                <div class="product-rating-stars">
                                    <span v-for="i in 5" class="star icon"
                                      :class="{'fill': i <= Math.round(item.product_rate)}"></span>
                                        <span>{{ item.product_rate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :ref="`item-${item.id}`" class="reviews-slider-item-content">
                    <div class="reviews-slider-item-content-tags">
                        <span class="item">Товар: {{ item.product_rate }}</span>
                        <span class="item">Сервис: {{ item.service_rate }}</span>
                        <span class="item">Доставка: {{ item.delivery_rate }}</span>
                    </div>
                    <div ref="text" class="reviews-slider-item-content-text">
                        <div ref="inner-text" class="reviews-slider-item-content-text-inner">{{ item.message }}</div>
                    </div>
                    <span v-if="isExpandable(item.id)" class="link link-more" @click.prevent="expandReview(item.id)">Читать полностью</span>
                    <span v-if="isExpandable(item.id)" class="link link-less" @click.prevent="collapseReview(item.id)">Свернуть</span>
                </div>
            </div>
        </template>
    </carousel>
</template>

<script>
import Carousel from "./Carousel";
import windowWidth from "../../mixins/windowWidth";

export default {
    props: ['items'],
    components: {
        Carousel,
    },
    mixins: [
        windowWidth
    ],
    data() {
        return {
            showNavigation: true,
            textLimit: 140,
            options: {
                spaceBetween: 20,
                loop: true,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    320: {
                        slidesPerView: 1,
                    }
                },
            },
        }
    },
    methods: {
        getItem(id) {
            return _.find(this.items, item => item.id === id);
        },
        isExpandable(id) {
            let item = this.getItem(id);
            if (item) {
                return item.message.length > this.textLimit;
            }
            return false;
        },
        expandReview(id) {
            let element = this.$refs[`item-${id}`];
            if (element) {
                element.classList.add('expanded');
            }
        },
        collapseReview(id) {
            let element = this.$refs[`item-${id}`];
            if (element) {
                element.classList.remove('expanded');
            }
        },
    }
}
</script>

